import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { map, find } from "lodash";
import Grid from "@mui/material/Grid";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { unicodeToString } from "../../../Js/Common";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import IconButton from "@mui/material/IconButton";
import AudioButton from "../../../Components/Media/AudioButton";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PauseIcon from "@mui/icons-material/Pause";
import { getWords, concatAllArrays } from "../../../Js/Common";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "presentation",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 1,
};

let audios = new Audio();

const AVP = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();
  const primaryMedia = useRef();
  const secondaryMedia = useRef();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [lines, setLines] = useState(null);
  let [currentLineIndex, setCurrentLineIndex] = useState(0);
  let [currentPhoneIndex, setCurrentPhoneIndex] = useState(0);
  let [isPlaying, setIsPlaying] = useState(false);
  let [allwords, setAllWords] = useState([]);

  // Redux state
  //   const { showAnswer, assetLogObj, attempted, currentAttempt } = useSelector(
  //     (state) => state.currentAsset
  //   );

  useEffect(() => {
    if (props.content) {
      let allWords = concatAllArrays(
        map(props.content.epage.options.content, "words")
      );
      const innerFun = async () => {
        let wordsData = await getWords(allWords);
        console.log("wordsData", wordsData.data);
        setAllWords(wordsData.data);
      };
      innerFun();
      setLines(props.content.epage.options.content);
      primaryMedia.current?.load();
      secondaryMedia.current?.load();
    }

    return () => {
      setLines([]);
      setCurrentLineIndex(0);
      setCurrentPhoneIndex(0);
      setIsPlaying(false);
      if (audios && !audios.paused) {
        audios.pause();
      }
    };
  }, [props.content]);

  useEffect(() => {
    console.log("&&&&isPlaying", isPlaying);
  }, [isPlaying]);

  const lineClick = (index) => {
    setCurrentLineIndex(index);
    if (audios && !audios.paused) {
      audios.pause();
    }
    if (
      props.content.epage.options.content[index]["media"] &&
      props.content.epage.options.content[index]["media"]["audio"]
    ) {
      audios.src = `${sessionStorage.getItem('media_url')}audio/${props.content.epage.options.content[index]["media"]["audio"]}`;
      audios.play();
    }
    primaryMedia.current?.load();
    secondaryMedia.current?.load();
  };

  const playPhoneAudio = (src, index) => {
    primaryMedia.current.pause();
    secondaryMedia.current.pause();
    if (audios && !audios.paused) {
      audios.pause();
    }
    audios.src = `${sessionStorage.getItem('media_url')}audio/${src}`;
    audios.play();
    setCurrentPhoneIndex(index);
    setIsPlaying(true);
    audios.onended = () => {
      setIsPlaying(false);
    };
  };

  const playVideo = (mediaIndex) => {
    primaryMedia.current.pause();
    secondaryMedia.current.pause();
    audios.pause();
    setIsPlaying(false);
    if (mediaIndex == 0) {
      primaryMedia.current.play();
    }
    if (mediaIndex == 1) {
      secondaryMedia.current.play();
    }
  };

  const wordFind = (id, key) => {
    let findObj = find(allwords, { uid: id });
    if (findObj) {
      return findObj[key];
    }

    return "";
  };

  const playWordAudio = (id) => {
    let findObj = find(allwords, { uid: id });
    if (findObj) {
      let content = typeof findObj.content == "string" ? JSON.parse(findObj.content):findObj.content;
      if (content.length > 0 && content[0]?.media?.audio) {
        if (audios && !audios.paused) {
          audios.pause();
        }
        audios.src = `${sessionStorage.getItem('media_url')}words_media/audio/${content[0]?.media?.audio}`;
        audios.play();
      }
    }
  };

  return (
    <Box
      sx={{
        borderRadius: 5,
        py: 2,
        mx: 6,
        mt: 1,
        height: "64vh",
      }}
    >
      <Grid
        container
        spacing={4}
        sx={{
          flexDirection: "row",
          flexFlow: "wrap",
          justifyContent: "center",
          px: 2,
        }}
      >
        <Grid item xs={4} px={2}>
          {lines &&
            lines.length > 0 &&
            lines[currentLineIndex]["media"] &&
            lines[currentLineIndex]["media"]["video"] && (
              <div
                style={{
                  textAlign: "center",
                  padding: "5px",
                  borderRadius: "5px",
                  background:
                    "linear-gradient(to bottom, rgba(0,16,107,0.5) 0%,rgba(148,155,193,0) 58%,rgba(244,244,244,0.7) 100%)",
                }}
              >
                {/* <div id={`playdiv_${props.data.myId.self}`} class="btn btnplay""></div>
      <div id={`pausediv_${props.data.myId.self}`} class="btn btnpause" style="display:none;"></div> */}
                <video
                  width="100%"
                  preload="auto"
                  disablePictureInPicture
                  controlsList="nodownload"
                  controls={true}
                  ref={primaryMedia}
                >
                  <source
                    src={`${sessionStorage.getItem('media_url')}video/${lines[currentLineIndex]["media"]["video"]}`}
                    type="video/ogg"
                  />
                  <source
                    src={`${sessionStorage.getItem('media_url')}video/${lines[currentLineIndex]["media"]["video"]}`}
                    type="video/mp4"
                  />
                </video>
              </div>
            )}

          {lines &&
            lines.length > 0 &&
            lines[currentLineIndex]["secondary_media"] &&
            lines[currentLineIndex]["secondary_media"]["video"] && (
              <div
                style={{
                  textAlign: "center",
                  padding: "5px",
                  borderRadius: "5px",
                  background:
                    "linear-gradient(to bottom, rgba(0,16,107,0.5) 0%,rgba(148,155,193,0) 58%,rgba(244,244,244,0.7) 100%)",
                }}
              >
                {/* <div id={`playdiv_${props.data.myId.self}`} class="btn btnplay""></div>
      <div id={`pausediv_${props.data.myId.self}`} class="btn btnpause" style="display:none;"></div> */}
                <video
                  width="100%"
                  preload="auto"
                  disablePictureInPicture
                  controlsList="nodownload"
                  controls={true}
                  ref={secondaryMedia}
                >
                  <source
                    src={`${sessionStorage.getItem('media_url')}video/${lines[currentLineIndex]["secondary_media"]["video"]}`}
                    type="video/ogg"
                  />
                  <source
                    src={`${sessionStorage.getItem('media_url')}video/${lines[currentLineIndex]["secondary_media"]["video"]}`}
                    type="video/mp4"
                  />
                </video>
              </div>
            )}
          {lines &&
            lines.length > 0 &&
            lines[currentLineIndex].media?.video &&
            lines[currentLineIndex].secondary_media?.video && (
              <Button
                sx={{
                  border: 1,
                  borderRadius: 10,
                  borderColor: "#EFEFEF",
                  color: "#FFFFFF",
                  backgroundColor: "#DB8829",
                  my: 1,
                 
                  "@media (min-width: 1636px)": {
                    fontSize: "1.2rem",
                  },
                }}
                variant="contained"
                fullWidth
                onClick={() => {
                  audios.pause();
                  primaryMedia.current.play();
                  secondaryMedia.current.play();
                }}
              >
                {"PLAY BOTH VIDEOS"}
              </Button>
            )}
        </Grid>
        <Grid item xs={8}>
          <Box
             
            sx={{ height: "52vh", overflow: "auto" }}
          >
            <>
              {props.content?.epage?.options?.common_text?.length > 0 &&
                props.content?.epage?.options?.common_text.map((ctxt, cind) => {
                  return (
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        backgroundColor: "#F5F7FF",
                        borderRadius: 10,
                        px: 2,
                        py: 1,
                        mt: cind > 0 ? 1 : 0,
                        overflow: "auto",
                        color: "#DB8829",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.6rem",
                        },
                      }}
                    >
                      {unicodeToString(ctxt.text)}
                    </Typography>
                  );
                })}
              {lines &&
                lines[0]["text"].trim().length > 0 &&
                lines.map((val, index) => {
                  return (
                    <Button
                      className={classes.ButtonWidth}
                      sx={{
                        border: 1,
                        borderRadius: 10,
                        borderColor:
                          currentLineIndex == index ? "#DB8829" : "#EFEFEF",
                        color:
                          currentLineIndex == index ? "#FFFFFF" : "#DB8829",
                        backgroundColor:
                          currentLineIndex == index ? "#DB8829" : "#FFFFFF",
                        mx: 2,
                        my: 1,
                        fontWeight: '600',
                        fontSize: "1rem",
                        textTransform: "inherit",
                       
                        "@media (min-width: 1636px)": {
                          fontSize: "1.6rem",
                        },
                      }}
                      onClick={() => {
                        lineClick(index);
                      }}
                    >
                      {unicodeToString(val.text)}
                    </Button>
                  );
                })}
            </>
            {lines &&
              lines[0].phonetic_text &&
              lines[0].phonetic_text.length > 0 &&
              lines[0].phonetic_text.map((val, index1) => {
                return (
                  <Box
                    className={classes.LineWidth}
                    sx={{
                      border: 1,
                      borderRadius: 10,
                      borderColor: "#EFEFEF",
                      px: 2,
                      py: 1,
                      my: 1,
                      textTransform: "inherit",
                      width: "90%",
                      lineBreak: "auto",
                      wordBreak: "break-all",
                    }}
                  >
                    <Grid container sx={{flexDirection: 'row', justifyContent: 'flex-start', alignItems:'center'}}>
                      <Grid item>
                        {val.media && val.media.audio && (
                          <IconButton
                            sx={{
                              color: "#FFFFFF",
                              backgroundColor: "#DB8829",
                              mx: 1,
                              padding: 0,
                             
                            }}
                            size="small"
                            onClick={() => {
                              playPhoneAudio(val.media.audio, index1);
                            }}
                          >
                            {isPlaying && currentPhoneIndex == index1 && (
                              <PauseIcon
                                sx={{
                                  borderRadius: "50%",
                                  padding: 1,
                                  color: "#FFFFFF",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2.2rem",
                                  },
                                }}
                              />
                            )}
                            {isPlaying && currentPhoneIndex != index1 && (
                              <MusicNoteIcon
                                sx={{
                                  borderRadius: "50%",
                                  padding: 1,
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2.2rem",
                                  },
                                }}
                              />
                            )}
                            {!isPlaying && (
                              <MusicNoteIcon
                                sx={{
                                  borderRadius: "50%",
                                  padding: 1,
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2.2rem",
                                  },
                                }}
                              />
                            )}
                          </IconButton>
                        )}
                      </Grid>
                      <Grid item flex={1}>
                        {val.richtext &&
                          val.richtext.length > 0 &&
                          val.richtext.map((val1, index2) => {
                            return (
                              <Typography
                                sx={
                                  val1.beautify.toLowerCase() == "bold"
                                    ? {
                                      display: 'inline-flex',
                                      margin: "0 3px",
                                      fontWeight: "800",
                                      fontSize: '1.15rem',
                                      cursor: "pointer",
                                      color: "#DB8829",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.7rem",
                                      },
                                    }
                                    : { margin: "0 3px",
                                    display: 'inline-flex',
                                    fontWeight: '500',
                                    fontSize: '1rem',
                                    color: "#DB8829",
                                    "@media (min-width: 1636px)": {
                                      fontSize: "1.4rem",
                                    }, }
                                }
                                onClick={() => {
                                  playVideo(val1.refrence_media);
                                }}
                              >
                                {val1.word}
                              </Typography>
                            );
                          })}
                      </Grid>
                    </Grid>


                  </Box>
                );
              })}
          </Box>
          {props.content?.epage?.options?.bottom_text?.length > 0 &&
            props.content?.epage?.options?.bottom_text.map((btxt, bind) => {
              return (
                <Typography
                  sx={{
                    fontSize: "0.9rem",
                    fontWeight: "500",
                    backgroundColor: "#F5F7FF",
                    borderRadius: 10,
                    px: 2,
                    py: 1,
                    overflow: "auto",
                    color: "#F44336",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                  fontStyle={"italic"}
                >
                  {unicodeToString(btxt.text)}
                </Typography>
              );
            })}
          {lines &&
            lines[currentLineIndex]["extra_words"].length > 0 &&
            unicodeToString(
              lines[currentLineIndex]["extra_words"][0]["text"]
            ) && (
              <Box
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: "500",
                  backgroundColor: "#F5F7FF",
                  borderRadius: 10,
                  px: 1,
                  py: 1,
                  overflow: "auto",
                }}
              >
                {lines[currentLineIndex]["extra_words"].map((words, windex) => {
                  return (
                    <Button
                      className={classes.ButtonWidth1}
                      sx={{
                        border: 1,
                        borderRadius: 10,
                        borderColor: "#EFEFEF",
                        color: "#DB8829",
                        backgroundColor: "#FFFFFF",
                        mx: 1,
                        my: 1,
                        textTransform: "inherit",
                       
                      }}
                    // onClick={() => {
                    //   lineClick(index);
                    // }}
                    >
                      {unicodeToString(words.text)}
                    </Button>
                  );
                })}
              </Box>
            )}

          {lines && lines[currentLineIndex]["words"].length > 0 && (
            <Box
               
              sx={{
                fontSize: "0.9rem",
                fontWeight: "500",
                backgroundColor: "#F5F7FF",
                borderRadius: 10,
                px: 1,
                py: 1,
                overflow: "auto",
                height: "10vh",
                mt: 1,
              }}
            >
              {lines[currentLineIndex]["words"].map((words, windex) => {
                return (
                  <Button
                    className={classes.ButtonWidth1}
                    sx={{
                      border: 1,
                      borderRadius: 10,
                      borderColor: "#EFEFEF",
                      color: "#DB8829",
                      backgroundColor: "#FFFFFF",
                      mx: 1,
                      my: 1,
                      textTransform: "inherit",
                    
                    }}
                    onClick={() => {
                      playWordAudio(words);
                    }}
                  >
                    {wordFind(words, "word_phrase")}
                  </Button>
                );
              })}
            </Box>
          )}
          {/* <Box
            sx={{
              mt: 2,
              backgroundColor: "#F5F7FF",
              borderRadius: 3,
              height: "14vh",
              overflow: "auto",
            }}
          >
            <Button
              className={classes.ButtonWidth1}
              sx={{
                borderRadius: 10,
                mx: 1,
                textTransform: "inherit",
                boxShadow: 1,
              }}
            >
              ou
            </Button>
            <Button
              className={classes.ButtonWidth1}
              sx={{
                borderRadius: 10,
                mx: 1,
                textTransform: "inherit",
                boxShadow: 1,
              }}
            >
              cb
            </Button>
            <Button
              className={classes.ButtonWidth1}
              sx={{
                borderRadius: 10,
                mx: 1,
                textTransform: "inherit",
                boxShadow: 1,
              }}
            >
              ay
            </Button>
            <Button
              className={classes.ButtonWidth1}
              sx={{
                borderRadius: 10,
                mx: 1,
                textTransform: "inherit",
                boxShadow: 1,
              }}
            >
              oh
            </Button>
            <Button
              className={classes.ButtonWidth1}
              sx={{
                borderRadius: 10,
                mx: 1,
                textTransform: "inherit",
                boxShadow: 1,
              }}
            >
              ue
            </Button>
          </Box> */}
        </Grid>
      </Grid>
    </Box>
  );
};
const useStyles = makeStyles({
  ButtonWidth: {
    width: "9rem",
  },
  LineWidth: {
    width: "90%",
  },
  ButtonWidth1: {
    width: "auto",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default AVP;
